import { TAppState } from '../../types/appState';

export function socketStatusSelector(state: TAppState) {
  return state.socketStatus;
}
